// src/components/PrioritySelect.js
import React from "react";
import { Select, MenuItem, Box } from "@mui/material";
import PropTypes from "prop-types";
import {
  Error as ErrorIcon,
  PriorityHigh as PriorityHighIcon,
  RemoveCircle as RemoveCircleIcon,
  LowPriority as LowPriorityIcon,
} from "@mui/icons-material";
import { red, green, purple, amber } from "@mui/material/colors";
const PrioritySelect = ({
  name = "priority",
  value,
  ticketData, 
  setTicketData, 
  raiseTicket,
  placeholder = "Select Priority",
  size = "small",
}) => {

  const options = [
  { value: "critical", label: "Critical", icon: <ErrorIcon />, color: red[600] },
  { value: "high", label: "High", icon: <PriorityHighIcon />, color: purple[600] },
  { value: "medium", label: "Medium", icon: <RemoveCircleIcon />, color: amber[600] },
  { value: "low", label: "Low", icon: <LowPriorityIcon />, color: green[600] },
];

  const handlePriorityChange = (e) => {
    const currentFormData = {
      ...ticketData,
      priority: e.target.value.toLowerCase(),
    };
    setTicketData(currentFormData);

    raiseTicket(currentFormData);
  };

  return (
    <Select
      name={name}
      size={size}
      value={value || ""}
      onChange={handlePriorityChange}
      displayEmpty
      disableUnderline
      renderValue={(selected) => {
        const option = options.find((o) => o.value === selected);
        return option ? (
          <Box
            sx={{
              display: "inline-flex",
              alignItems: "center",
              backgroundColor: option.color,
              color: "#fff",
              fontWeight: "bold",
              padding: "6px 12px",
              borderRadius: "8px",
              fontSize: "14px",
            }}
          >
            {option.label}
          </Box>
        ) : (
          <span style={{ color: "#999", fontSize: "14px" }}>{placeholder}</span>
        );
      }}
      sx={{
        minWidth: 100,
        borderRadius: "3px",
        padding: "0px 6px",
        "& .MuiSelect-select": {
          display: "flex",
          alignItems: "center",
        },
        "& fieldset": {
          border: "none", // Remove border
        },
      }}
    >
      {options.map((option) => (
        <MenuItem
          key={option.value}
          value={option.value}
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            fontWeight: "500",
          }}
        >
          <Box
            sx={{
              width: 12,
              height: 12,
              borderRadius: "50%",
              backgroundColor: option.color,
            }}
          />
          {option.label}
        </MenuItem>
      ))}
    </Select>
  );
};

PrioritySelect.propTypes = {
  name: PropTypes.string,
  value: PropTypes.string.isRequired,
  // onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      color: PropTypes.string.isRequired,
    })
  ).isRequired,
  ticketData: PropTypes.object.isRequired,
  setTicketData: PropTypes.func.isRequired,
  raiseTicket: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  size: PropTypes.string,
};

export default PrioritySelect;
